import React, { useState, useContext, useEffect } from 'react';
import axios from '../../../axios/index';
// Context
import { UserContext } from '../../Context/UserContextProvider';

// styles
// import styles from "./UserProfile.module.css"
import Dstyles from "../UserMyAds/UserMyAds.module.css"
import loaderStyles from "../../Dashboard/DashboardFileManagement/DashboardFileManagement.module.css"

// components
import HomeNavbar from './../../Home/HomeNavbar/HomeNavbar';
import UserSideDashboard from '../UserSideDashboard/UserSideDashboard';
import Footer from '../../Home/Footer/Footer';
import UserProfileInfo from './UserProfileInfo';

export default function UserProfile() {
    const { userToken } = useContext(UserContext);
    const [isLoading, setIsLoading] = useState(true)
    const [userData, setUserData] = useState(false)

    useEffect(() => {
        const usersDataHandler = async () => {
            // setIsLoading(true)
            const getUserData = await axios.get(
                `Users/Current`,
                {
                    headers: { authorization: "Bearer " + userToken },
                }
            );
            setUserData(getUserData.data.data);
            // console.log(getUserData.data.data);
            setIsLoading(false)
        }
        usersDataHandler();
    }, [userToken])

    return (
        <>
            {isLoading ? (
                <div className={loaderStyles.loader_container}>
                    <div className={loaderStyles.spinner}></div>
                </div>
            )
                : (
                    <div className="d-flex justify-content-center align-items-start vw-100 position-relative" dir='rtl'>
                        <div className="w-100 ms-0 p-0" style={{ background: "#FFFFFF" }}>
                            <HomeNavbar />
                            <div className="container py-3 px-0 mt-4">
                                <div className='w-100 d-flex justify-content-md-between justify-content-center align-items-start'>
                                    <UserSideDashboard />
                                    <div className={`d-flex flex-column align-items-center justify-content-start p-4 ${Dstyles.main_container}`}>
                                        <div className='w-100 d-flex align-items-center justify-content-md-between justify-content-center flex-wrap mb-5'>

                                            <div className={`my-md-0 my-2 ${Dstyles.title}`}>
                                                پروفایل کاربری
                                            </div>

                                            <UserProfileInfo avatarName={userData?.avatarName} userData={userData} userToken={userToken} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Footer />
                        </div>
                    </div>
                )}

        </>
    )
}
